module.exports = __webpack_public_path__ + "static/media/calendar-arrow-left-green.31335039.svg";